import React     from "react";
import PropTypes from 'prop-types';
import Flux      from '../../flux/Flux';
import Alert, { BUTTON } from "../Alert/Alert";
import { getTypeByColor } from "./Constants";

class StatusBarError extends React.Component {

	static onClick() {
		Flux.Browser.setShowStatusBar(false);
	}

	constructor(props) {
		super(props);
		this.state = {
			isVisible: this.props.isVisible,
		};

		this.onShowStatusBarChange = this.onShowStatusBarChange.bind(this);
	}

	UNSAFE_componentWillMount() {
		Flux.Browser.addShowStatusBarChangeListener(this.onShowStatusBarChange);
	}

	componentWillUnmount() {
		Flux.Browser.removeShowStatusBarChangeListener(this.onShowStatusBarChange);
	}

	onShowStatusBarChange(showStatusBar) {
		this.setState({
			isVisible: showStatusBar,
		});
	}


	render() {
        if (!this.state.isVisible) {
            return null;
        }

        const button = this.props.btnLabel ? [{type: BUTTON.SECONDARY, text: this.props.btnLabel, onClick: StatusBarError.onClick}] : [];

        return <Alert
            type={getTypeByColor(this.props.barColor)}
            text={this.props.msgIntro ? this.props.msgIntro : "" + " " + this.props.msgOutro ? this.props.msgOutro : ""}
            buttons={button}
        />;
	}
}

StatusBarError.propTypes = {
	barColor:        PropTypes.string.isRequired,
	msgIntro:        PropTypes.string,
	msgOutro:        PropTypes.string,
	btnLabel:        PropTypes.string,
	isVisible:       PropTypes.bool,
};

StatusBarError.defaultProps = {
	isVisible:       false,
};

export default StatusBarError;
